import { GitBranch } from "lucide-react";
import { RiskBadge } from "@/modules/collector_v2/components/common/RiskBadge";
import { formatNumber } from "@/modules/collector_v2/lib/formatters";

export function RelationshipRow({ rel }) {
  return (
    <div className="relationship-row" data-testid="relationship-row">
      <GitBranch className="h-4 w-4" />
      <div><strong>{rel.uid_a} ↔ {rel.uid_b}</strong><span>{formatNumber(rel.co_hands)} manos · swings {formatNumber(rel.profit_swings)}</span></div>
      <RiskBadge level={rel.risk_level} score={rel.risk_score} testid="relationship-risk-badge" />
    </div>
  );
}
